import { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Card, SearchTable } from 'components'

import { sortObjectsWithChildren, tableHeaders } from '../config'
import ApiHelper from 'helpers/ApiHelper'
import { prefetchQuery } from 'helpers/QueryHelper'

export default function AdminObjectsFindView() {
  const { t } = useTranslation()
  const history = useHistory()
  const tableRef = useRef()
  const refreshRef = useRef()

  return (
    <Card cardType="primary-content" className="mb-4 h-full">
      <SearchTable
        apiName="find_objects"
        dataFormatter={sortObjectsWithChildren}
        dataApi={(query) => ApiHelper.queryObjects(query)}
        tableRef={tableRef}
        refreshRef={refreshRef}
        filterCacheKey="find_objects"
        filterDebounce={true}
        initialSort={{ id: 'name', desc: false }}
        placeholder={t('application:search')}
        removeFooter={true}
        expandable={true}
        scrollRestore={true}
        rowOnClick={(row) => {
          prefetchQuery(
            ['object', row.objectId, { accessLevel: 'access' }],
            row
          )
          history.push(`/objects/find/${row.objectId}`)
        }}
        tableHeaders={tableHeaders['access']}
      />
    </Card>
  )
}
